<template>
  <div class='InitColorPicker' :style="{ width: computedWidth }">
    <div class="label">{{ label }} {{ required ? '*' : '' }}</div>
    <div class="cont-picker">
      <div class="color-picker">
        <div class="cont-trigger">
          <color-picker
          format="hex"
          :pure-color="value"
          @pureColorChange="(c) => selectColor(c)"
          pickerType="chrome"
          />
        </div>
      </div>
      <div class="cont-input">
        <input type="text" :value="value">
      </div>
    </div>
  </div>
</template>

<script>
import { ColorPicker } from "vue3-colorpicker"
export default {
  name: 'InitColorPicker',
  components: { ColorPicker },
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    required: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    value: {
      type: String,
      default: '#FFFFFF'
    }
  },
  computed: {
    computedWidth () {
      return window.innerWidth < 500 ? '100%' : this.width
    }
  },
  methods: {
    selectColor (color) {
      this.$emit('returnValue', color)
    }
  }
}
</script>

<style scoped>
.InitColorPicker {
  width: 100%;
  text-align: left;
}

.label {
  font-size: 12px;
  font-weight: 900;
}

.cont-picker {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.color-picker {
  width: 8%;
  border: thin solid #CCCCCC;
  padding: 1%;
}

.cont-trigger {
  width: 25px;
  height: 25px;
  overflow: hidden;
}

.cont-input {
  display: flex;
  border: thin solid #CCCCCC;
  width: 80%;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 1px 1px 2px 0.5px #CCCCCC;
}

input {
  width: 100%;
  border: 0;
}

input:focus {
  outline: none;
}
</style>
